import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { userType } from "../../../Services/postServices";
import { loader } from "../../../redux/type";
import { getZoneList } from "../../../Services/getServices";
import { addAdminUser } from "../../../Services/postServices";
const AdminWaterBill = (props) => {
  const dispatch = useDispatch();
  const mobNum = localStorage.getItem("moblie");
  const userData = JSON.parse(localStorage.getItem("user"));
  console.log("DOMAINCIODE=", props?.data?.domainCode);
  const domCode = props?.data?.domainCode;
  

  const id = userData?.domainCodesByUserId[0]?.userId;

  var [tit, setTit] = useState("");
  var [firstName, setFirstName] = useState("");
  var [middleName, setMiddleName] = useState("");
  var [lastName, setLastName] = useState("");
  var [fatherName, setFatherName] = useState("");
  var [aadhaarNo, setAadhaarNo] = useState("");
  var [mobileNo, setMobileNo] = useState("");
  var [panNo, setPanNo] = useState("");
  var [email, setEmail] = useState("");
  var [gender, setGender] = useState("");
  var [dob, setDob] = useState("");
  var [consumerId, setConsumerId] = useState("");
  var [domainCo, setDomainCo] = useState("");
var[name,setName]=useState("");
    var [userId, setUserId] = useState("");
    var [pass, setPass] = useState("");
  var [useType,setUseType]=useState("");
  var[zone,setZone]=useState("")
  var [userTy, setUserTy] = useState([]);
  var [zoneArr,setZoneArr]=useState([]);

  useEffect(() => {
    userTydetails();
    zoneList();
  }, []);

  function userTydetails() {
    userType(domCode, (res) => {
      if (res?.data?.status) {
        setUserTy(res?.data?.result);
      } else {
      }
    });
  }

   function zoneList() {
      dispatch({ type: loader.startLoader });
  
      getZoneList((res) => {
        dispatch({ type: loader.stopLoader });
        if (res?.data?.status) {
          setZoneArr(res?.data?.result);
          console.log("ZONE=",res?.data?.result)
        } else {
        }
      });
    }


     function addUser() {
        let req = {
          userName: userId,
          createdBy: id.toString(),
    
          emailId: email,
    
          mobileNumber: mobileNo,
    
          firstName: name,
    
          zone: zone,
          domainCode: domCode,
    
          // designation: desig,
          isAdmin: "Y",
          // roles: [4],
          userType: useType,
    
          password: pass,
          retypePassword: pass,
    
          // departmentName: domainC,
    
          isAdmin: "Y",
          // "roles":[1,2,3,4],
          // dob: "2005-02-02",
        };
        dispatch({ type: loader.startLoader });
        addAdminUser(req, (res) => {
          dispatch({ type: loader.stopLoader });
          if (res?.data?.status) {
            toast.success(res?.data?.message);
            window.location.reload();
          } else {
            toast.error(res?.data?.message);
          }
        });
      }

  return (
    <>
      <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          <h4 className="h2_heading">Water Bill</h4>

          <div className="row  ">
            

          <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Name:
                </label>
                <input
                  type="mobile"
                    onChange={(e) => setName(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
            
            <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Email Id:
                </label>
                <input
                  type="mobile"
                    onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
            <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Mobile No:
                </label>
                <input
                  type="mobile"
                    onChange={(e) => setMobileNo(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
            
           
            <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  User Type:
                </label>
                <select
                  class="form-control form-select"
                  onChange={(e) => {
                    setUseType(e.target.value);
                  }}
                >
                  <option value="0">Select Usertype </option>

                  {userTy.map((val) => {
                    return (
                      <option key={val} value={val.id}>
                        {val.userTypeName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Zone:
                </label>
                <select
                  class="form-control form-select"
                  onChange={(e) => {
                    setZone(e.target.value);
                  }}
                >
                  <option value="0">Select Zone </option>

                  {zoneArr.map((val) => {
                    return (
                      <option key={val} value={val.id}>
                        {val.zoneName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            
            <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  User Id:
                </label>
                <input
                  type="text"
                  onChange={(e) => setUserId(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
            <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Password:
                </label>
                <input
                  type="text"
                  onChange={(e) => setPass(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                  //   value={domainCode}
                  // disabled
                />
              </div>
            </div>
          
            <div className="col-4 ">
          <div className="form-outline " style={{marginTop:"2rem"}}>
            <button className="btn btn-primary" onClick={addUser}>
              Create Admin
            </button>
          </div>
        </div>
         
            
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminWaterBill;
